import { CallApi } from '@signavio/kraken'

import { schema as taskSchema } from './task'

export { collection } from './task'
export const schema = taskSchema

export const create =
  (callApi: CallApi, apiBase: string) =>
  (_: unknown, { id, body }: { id: string; body: object }) =>
    callApi(`${apiBase}/tasks/${id}/complete`, schema, { method: 'POST', body })
